/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Linear_Th6Inputs */

const en_mk_cmp_linear_th6 = /** @type {(inputs: Mk_Cmp_Linear_Th6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English.`)
};

const id_mk_cmp_linear_th6 = /** @type {(inputs: Mk_Cmp_Linear_Th6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inggris.`)
};

/**
* | output |
* | --- |
* | "English." |
*
* @param {Mk_Cmp_Linear_Th6Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_linear_th6 = /** @type {((inputs?: Mk_Cmp_Linear_Th6Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Linear_Th6Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_linear_th6(inputs)
	return en_mk_cmp_linear_th6(inputs)
});